module.exports = __webpack_public_path__ + "static/media/receipt.7640e66f.svg";